/* @flow */

import {
    type Pedido,
} from './types';

const getTimeEntrada = (pedido: Pedido) => new Date(pedido.etapa.entrada).getTime();

const getDataMaisAntigaPedidos = (pedidos: Pedido[]): number => (
    pedidos.reduce((data, pedido) => Math.min(data, getTimeEntrada(pedido)), Infinity)
);

export default getDataMaisAntigaPedidos;
